// extracted by mini-css-extract-plugin
export default {"header":"header_header__n-qNO","paperContainer":"header_paperContainer__bI6MP","headerBanner":"header_headerBanner__WEXA-","menuAndMuhurtham":"header_menuAndMuhurtham__e4ioe"};